/**
 * Slim row model returned by `POST /appointment/search`. Backed by
 * `AppointmentListItemOutputMessage` in Leo.Cars.Raptor.Message.Appointments on the
 * backend. Drives the omni-web / marlin-web "Completed Appointments" list and any
 * future appointment list surface that reuses the generic search endpoint.
 */
export interface AppointmentListItem {
    id: string;
    customerName?: string;
    licensePlate?: string;
    workOrderNumber?: string;
    checkedInDateTime?: string;
    advisorName?: string;
}

/**
 * Which appointment property the FE keyword filter targets. FE-only -- the BE
 * resolves the keyword via a `SearchCriteriaItem` whose `name` is the property
 * path (`customer.name`, `vehicle.licenseplate`, `workorder.number`). The enum
 * exists so the dropdown UI can map a friendly label to that path.
 */
export enum AppointmentSearchField {
    CustomerName = 'CustomerName',
    LicensePlate = 'LicensePlate',
    WorkOrderNumber = 'WorkOrderNumber',
}
